import { render } from "./RcdForm.vue?vue&type=template&id=54b2d3b3"
import script from "./RcdForm.vue?vue&type=script&lang=js"
export * from "./RcdForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__